module.exports = __webpack_public_path__ + "img/emoji/bbetdice.d80ecc282ebe514841f101841e2599aa.png";